import React from 'react';
import { t } from '@lingui/core/macro';
import { FieldRow, SectionCard, TextField } from 'src/components/forms';
import { OrgUnitRecord } from './orgUnitModel';

export type AddressSectionProps = {
  draft: OrgUnitRecord;
  setField: (path: string, value: unknown) => void;
  errorFor: (path: string) => string | undefined;
};

export function AddressSection({ draft, setField, errorFor }: AddressSectionProps) {
  const field = (id: string, path: string, label: string, width: 'xs' | 'sm' | 'md' | 'lg', required: boolean) => (
    <TextField id={id} label={label} required={required} width={width} value={draft[path] as string} error={errorFor(path)} onChange={value => setField(path, value)} />
  );

  return (
    <SectionCard span={12} title={t`Address`}>
      <FieldRow>
        {field('orgunit-address1', 'address1', t`Address Line 1`, 'lg', true)}
        {field('orgunit-address2', 'address2', t`Address Line 2`, 'lg', false)}
        {field('orgunit-city', 'city', t`City`, 'md', true)}
        {field('orgunit-state', 'state', t`State`, 'sm', true)}
        {field('orgunit-postal-code', 'postalCode', t`Postal Code`, 'xs', true)}
      </FieldRow>
    </SectionCard>
  );
}

export default AddressSection;
